<template>
  <div>
    <p v-if="renewalCopy" class="mtop-20 fine-print-lg bold" data-cy="copy--renewal">{{renewalCopy}} You may cancel your subscription at any time from the <router-link :to="{name: 'account'}" target="_blank">My Account </router-link>page. For help, <router-link :to="{name: 'support'}" target="_blank">contact support</router-link>.</p>
  </div>
</template>

<script>
import products from '@/data/product-details.js'
import services from '../../services/services.js'
export default {
  name: 'subscription-info',
  props: {
    'pricing': Object,
    'pricingValues': Object,
    'config': Object
  },
  data () {
    return {
      products
    }
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.userData
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    isYearlySubscription: function () {
      return this.products[this.config.productName].cycleMonths > 1
    },
    isUserSubscribed: function () {
      return this.isLoggedIn && this.isYearlySubscription && this.currentUser.recurring
    },
    priceDiff: function () {
      return this.pricingValues[this.config.productName].chargePrice !== this.pricingValues[this.config.productName].regularPrice
    },
    renewalCopy: function () {
      let renewalCopy = ''
      if (this.products[this.config.productName].renews) {
        const months = this.products[this.config.productName].cycleMonths
        const cycle = months > 1 ? ' annually' : 'monthly'
        const taxCopy = (this.tax ? ' ' + this.tax + '.' : '.')
        const priceCopy = this.pricingValues[this.config.productName].regularPrice
        renewalCopy = `Your order includes a subscription that automatically renews ${cycle} unless canceled. By subscribing, you authorize TunnelBear to automatically charge the card on file for each renewal term at $ ${priceCopy} USD.`
      }
      return renewalCopy
    }
  }
}
</script>
